module.exports = {
    // 头部菜单
    header_menu: {
        logout: 'sign out',
        index: 'ホームページ',
        game: 'ゲーム',
        news: 'ニュース',
        about: '会社概要',
        JoinUs: 'キャリアを見る',
        Join: 'キャリアを見る',
    },
    // 标题
    title: {
        gname: 'ゲーム',
        gmore: 'その他',
        nname: 'ニュース',
        nmore: 'その他'
    },
    //按钮
    btn: {
        explore: 'サーチ',
        website: '公式サイト'
    }
}


// WEBPACK FOOTER //
// ./src/language/jp.js